import axios from 'axios';

export const getMySubscriptions = async () => {
    try {
        const response = await axios.get('/api/teacher/my-subscriptions', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching my subscriptions:', error);
        throw error;
    }
};

export const addSchedule = async (subscriptionId, scheduleData) => {
    try {
        const response = await axios.post(`/api/teacher/subscriptions/${subscriptionId}/schedules`, scheduleData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error adding schedule:', error);
        throw error;
    }
};
